import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonItem,
  IonModal,
  IonTitle,
  IonToggle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ConsentService } from './consent.service';

@Component({
  selector: 'app-cookie-consent-shell',
  templateUrl: './cookie-consent-shell.component.html',
  styleUrls: ['./cookie-consent-shell.component.scss'],
  imports: [
    RouterLink,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonFooter,
    IonItem,
    IonToggle,
  ],
})
export class CookieConsentShellComponent {
  readonly consent = inject(ConsentService);

  readonly draftAnalytics = signal(false);
  readonly draftFeedback = signal(false);

  initDraftFromService(): void {
    const s = this.consent.state();
    if (!s) {
      return;
    }
    this.draftAnalytics.set(s.analytics);
    this.draftFeedback.set(s.feedbackWidget);
  }

  onModalDidPresent(): void {
    this.initDraftFromService();
  }

  async onNecessary(): Promise<void> {
    await this.consent.acceptNecessaryOnly();
  }

  async onAcceptAll(): Promise<void> {
    await this.consent.acceptAllOptional();
  }

  async onSaveCustom(): Promise<void> {
    await this.consent.saveCustomPreferences(this.draftAnalytics(), this.draftFeedback());
  }

  onModalDismiss(): void {
    this.consent.closeCookieSettings();
  }
}
